import type { RenderContext, VideoFrame } from '../../types';
import { BaseEffect } from '../base';
import { stableEffectSeed, withOverlay } from './composite';
import { buildRainParticles, drawRain } from '../../particles/engine';

const DEFAULTS = { density: 0.6, speed: 1, wind: 0.3, dropSize: 0.5 };

export class RainEffect extends BaseEffect {
  constructor(id: string, clip: Partial<import('../../types').EffectTimelineClip>) {
    super(id, 'rain', clip, DEFAULTS);
  }

  protected renderGpu(frame: VideoFrame, params: Record<string, number>, context: RenderContext): VideoFrame {
    return this.renderCpu(frame, params, context);
  }

  protected renderCpu(frame: VideoFrame, params: Record<string, number>, context: RenderContext): VideoFrame {
    const seed = stableEffectSeed(context, this.id);
    const particles = buildRainParticles(
      frame.width, frame.height, params.density, params.speed, params.wind, params.dropSize,
      context.frameIndex, seed,
    );
    return withOverlay(frame, (ctx) => drawRain(ctx, particles, params.wind), 'lighter');
  }
}
